import * as React from "react";
const MobileSidebarIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <rect width={39} height={39} x={0.5} y={0.5} stroke="#AEBBCB" rx={19.5} />
    <mask
      id="a"
      width={24}
      height={24}
      x={8}
      y={8}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M8 8h24v24H8z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#64748B"
        d="M14 28c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 12 26c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 14 24c.55 0 1.02.196 1.412.587.392.392.588.863.588 1.413s-.196 1.02-.588 1.413A1.926 1.926 0 0 1 14 28Zm6 0c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 18 26c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 20 24c.55 0 1.02.196 1.413.587.391.392.587.863.587 1.413s-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 28Zm6 0c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 24 26c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 26 24c.55 0 1.02.196 1.413.587.391.392.587.863.587 1.413s-.196 1.02-.587 1.413A1.926 1.926 0 0 1 26 28Zm-12-6c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 12 20c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 14 18c.55 0 1.02.196 1.412.587.392.392.588.863.588 1.413s-.196 1.02-.588 1.413A1.926 1.926 0 0 1 14 22Zm6 0c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 18 20c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 20 18c.55 0 1.02.196 1.413.587.391.392.587.863.587 1.413s-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 22Zm6 0c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 24 20c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 26 18c.55 0 1.02.196 1.413.587.391.392.587.863.587 1.413s-.196 1.02-.587 1.413A1.926 1.926 0 0 1 26 22Zm-12-6c-.55 0-1.02-.196-1.412-.588A1.926 1.926 0 0 1 12 14c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 14 12c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412 0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 14 16Zm6 0c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 18 14c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 20 12c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412 0 .55-.196 1.02-.587 1.412A1.926 1.926 0 0 1 20 16Zm6 0c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 24 14c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 26 12c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412 0 .55-.196 1.02-.587 1.412A1.926 1.926 0 0 1 26 16Z"
      />
    </g>
  </svg>
);
export default MobileSidebarIcon;
